import React, { useState, useEffect, useRef } from "react";
import Spline from "@splinetool/react-spline";
import { Link, useNavigate } from "react-router-dom";
import "./landingpage.css";
import NotificationPopup from "../notificationpopup/notificationpopup";

import Arjunpopup from "../notificationpopup/arjunpopup";

const slides = [
  {
    id: 1,
    title: "Welcome To !!\n India's First Andro Humanoid Manufacturing Company",
    content: null,
    gradientClass: "gradient-1",
    splineScene: "https://prod.spline.design/UAq9wnNasyW4JWfz/scene.splinecode",
  },
  {
    id: 2,
    title: "Discover Robotics Like Never Before",
    content: "Operate next-generation android systems at scale.",
    gradientClass: "gradient-2",
    splineScene: "https://prod.spline.design/UAq9wnNasyW4JWfz/scene.splinecode",
  },
];  

const LandingPage = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [config, setConfig] = useState(null); 
  const [message, setMessage] = useState(null);
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [data, setData] = useState(null); 
  const slideCount = slides.length;
  const intervalRef = useRef(null);
  const navigate = useNavigate();




  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch("/config.json");
        const data = await res.json();
        setConfig(data);
      } catch (err) {
        console.error("Failed to load config.json", err);
      }
    };
    loadConfig();
  }, []);


  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await fetch("/data.json");
        if (!res.ok) {
          throw new Error("Failed to fetch data.json");
        }
        const dataJson = await res.json();
        setData(dataJson);
      } catch (err) {
        console.error("Failed to load data.json", err);
      }
    };
    loadData();
  }, []);

  const bubbles = Array.from({ length: 8 }).map((_, i) => (
    <div key={i} className="bubble" />
  ));

  const nextSlide = () => setActiveSlide((prev) => (prev === slideCount - 1 ? 0 : prev + 1));
  const prevSlide = () => setActiveSlide((prev) => (prev === 0 ? slideCount - 1 : prev - 1));

  useEffect(() => {
    if (!config) return; 
    const checkSession = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.CHECK_SESSION}`, {
           method: "POST",
          credentials: "include",
        });
        const data = await res.json();
        setIsLoggedIn(data.active);
      } catch (err) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, [config]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600 && showMobileNav) {
        setShowMobileNav(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [showMobileNav]);

  const handleLogout = async () => {
    if (!config) return;
    try {
      const res = await fetch(`${config.BASE_URL}${config.USER_LOGOUT}`, {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();
      if (data.status) {
        setIsLoggedIn(false);
        setMessage("Logged out successfully");
      } else {
        setMessage("Logout failed");
      }
    } catch (err) {
      setMessage("Error logging out");
    }
  };

  useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setActiveSlide((prev) => (prev === slideCount - 1 ? 0 : prev + 1));
      }, 5000);
    }
    return () => clearInterval(intervalRef.current);
  }, [activeSlide, isPaused, slideCount]);


  const edutechLink = data?.['Edutech-link'] || '#';

  return (
    <>
    <div className={`page-container ${slides[activeSlide].gradientClass}`}>
      <div className="gradient-background"></div>
      <div className="bubbles">{bubbles}</div>

      <div className="fixed-logo">
        <img src="/Rc.png" alt="Logo" className="header-logo" />
      </div>

      <header className="header">
        {/* Desktop nav */}
        <nav className="nav-center">
          <Link to='/about' className="glassy-button">About</Link>
          <Link to='/products' className="glassy-button">Products</Link>
          <div className="dropdown-container">
            <button className="glassy-button dropdown-toggle">
              Services <span className="dropdown-arrow">▼</span>
            </button>
            <div className="dropdown-menu">
              <a 
                href={edutechLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="dropdown-item"
              >
                Edutech
              </a>

              <Link to="/pcb-design" className="dropdown-item">PCB Designing</Link>
              <Link to="/3dprinting" className="dropdown-item">3D Printing</Link>
              <Link to='/internships' className="dropdown-item">Internships</Link>
              <Link to='/project-list' className="dropdown-item">Project List</Link>
            </div>
          </div>
        </nav>

        {/* Hamburger */}
        <button
          className={`hamburger ${showMobileNav ? "active" : ""}`}
          onClick={() => setShowMobileNav(!showMobileNav)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile nav menu */}
        <nav className={`mobile-nav ${showMobileNav ? "show" : ""}`}>
          <Link to='/about' onClick={() => setShowMobileNav(false)}>About</Link>
          <Link to='/products' onClick={() => setShowMobileNav(false)}>Products</Link>
          <a 
          href={edutechLink}
          target="_blank" 
          rel="noopener noreferrer" 
          className="dropdown-item"
        >
          Edutech
        </a>

          <Link to='/pcb-design' onClick={() => setShowMobileNav(false)}>PCB Designing</Link>
          <Link to="/3dprinting" onClick={() => setShowMobileNav(false)}>3D Printing</Link>
          <Link to='/internships' onClick={() => setShowMobileNav(false)}>Internships</Link>
          <Link to='/project-list' onClick={() => setShowMobileNav(false)}>Project List</Link>
         {isLoggedIn ? (
     <>
    <button 
      className="premium-glass-button mobile-button" 
      onClick={() => { navigate("/account"); setShowMobileNav(false); }}
    >
      <span className="button-glow"></span>
      <span className="button-text">Profile</span>
    </button>
    <button 
        className="premium-glass-button mobile-button" 
        onClick={() => { 
          setShowLogoutConfirm(true); 
          setShowMobileNav(false); 
        }}
      >
        <span className="button-text">Logout</span>
      </button>

        </>
      ) : (
        <button 
          className="premium-glass-button mobile-button" 
          onClick={() => { navigate("/login"); setShowMobileNav(false); }}
        >
          <span className="button-glow"></span>
          <span className="button-text">Login</span>
        </button>
      )}

        </nav>

        <div className="header-right">
           {isLoggedIn ? (
          <>
            <button 
              className="premium-glass-button" 
              onClick={() => navigate("/account")}
            >
              <span className="button-glow"></span>
              <span className="button-text">Profile</span>
            </button>
            <button 
            className="premium-glass-button" 
            onClick={() => setShowLogoutConfirm(true)}
          >
            <span className="button-text">Logout</span>
          </button>
          </>
          ) : (
            <button className="premium-glass-button" onClick={() => navigate("/login")}>
              <span className="button-glow"></span>
              <span className="button-text">Login</span>
            </button>
          )}
        </div>
      </header>

      <div
        className="slider-wrapper"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div
          className="slides-container"
          style={{ transform: `translateX(-${activeSlide * 100}vw)` }}
        >
          {slides.map(({ id, title, content }) => (
            <div className="slide" key={id}>
              <h1 style={{ whiteSpace: "pre-line" }}>{title}</h1>
              {content && <p>{content}</p>}
            </div>
          ))}
        </div>
      </div>

      <div className="spline-scene">
        <Spline scene={slides[activeSlide].splineScene} />
      </div>

      <button className="nav-button prev" onClick={prevSlide}>
        <span>&lt;</span>
      </button>
      <button className="nav-button next" onClick={nextSlide}>
        <span>&gt;</span>
      </button>

      <div className="landing-notification-float">
        <Link to="/arjunpage" style={{ textDecoration: "none" }}>
          <Arjunpopup />
        </Link>
      </div>

      <NotificationPopup />
      {showLogoutConfirm && (
  <div 
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
    }}
  >
    <div 
      style={{
        background: "white",
        padding: "20px 30px",
        borderRadius: "12px",
        maxWidth: "400px",
        textAlign: "center",
        boxShadow: "0 6px 20px rgba(0,0,0,0.3)"
       
      }}
    >
      <h3 style={{ marginBottom: "15px" }}>Hello, Human!</h3>
      <p style={{ marginBottom: "20px" }}>Logging out will end our connection. Proceed?</p>
      
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <button 
          className="premium-glass-button" 
          style={{ color: "black" }}
          onClick={() => setShowLogoutConfirm(false)}
        >
          Cancel
        </button>
        <button 
          className="premium-glass-button" 
          style={{ color: "black" }}
          onClick={() => {
            handleLogout();
            setShowLogoutConfirm(false);
          }}
        >
          Yes, Logout
        </button>
      </div>
    </div>
  </div>
)}


      {message && (
        <div
          style={{
            position: "fixed",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "15px 20px",
            borderRadius: "12px",
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            color: "black",
            fontSize: "14px",
            fontWeight: "500",
            zIndex: 1000,
            minWidth: "250px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <span>{message}</span>
          <span
            style={{ marginLeft: "15px", cursor: "pointer" }}
            onClick={() => setMessage(null)}
          >
            ×
          </span>
        </div>
      )}
    
    </div>
    {/* <BelowcontentPage activeSlide={activeSlide} /> */}
  </>
  );
};

export default LandingPage;
